import {ForeignKey, Model, isEmpty} from "weed-js";
import {Organization} from "./sso.js";
import {Client} from "weed-js";



export class StripeModel extends Model {

    static dal() {
        const client = new Client();
        return client.sso.dal.v1();
    }
}

export class Product extends StripeModel {
    static columns = ["id", "external_id", "name", "description", "price_external_id", "environment", "unit_price"];
    static pluralName = "stripe_products";
    static uri = "/stripe-products/";

    static dutchiePriceExternalIds = [
        "price_1RX54WFy88bsb57ujNsJGliK",
        "price_1RX4tICEhkWRjCsPwSdVD4Jq",
    ];

    static metrcPriceExternalIds = [
        "price_1RxufhFy88bsb57uKxfnWN7p",
        "price_1RyH03CEhkWRjCsPc6hBehvk",
    ];

    isDutchie() {
        console.log("Checking if product is Dutchie, price_external_id:", this.price_external_id, "Known Dutchie IDs:", Product.dutchiePriceExternalIds);
        return Product.dutchiePriceExternalIds.includes(this.price_external_id);
    }

    isMetrc() {
        return Product.metrcPriceExternalIds.includes(this.price_external_id);
    }
}

export class Customer extends StripeModel {
    static columns = ["id", "external_id", "organization_id", "email", "name", "phone", "active"];
    static uri = "/stripe-customers/";
    static pluralName = "customers";

    static foreignKeys = {
        organization: new ForeignKey(Organization)
    };
}

export class Subscription extends StripeModel {
    static columns = ["id", "external_id", "organization_id", "user_id", "status"];
    static uri = "/subscriptions/";
    static pluralName = "subscriptions";

    static foreignKeys = {
        organization: new ForeignKey(Organization),
    };

    isActive() {
        return this.status === "active" || this.status === "trialing";
    }

    getMaximumDutchieStores() {
        if (this.status !== "active" && this.status !== "trialing") {
            console.log("No active or trialing subscription, got status: ", this.status);
            return 0;
        }
        if (isEmpty(this.items)) {
            console.log("Subscription has no items");
            return 0;
        }
        let count = 0;
        const items = Array.from(this.items);
        for (let i=0; i < items.length; i++) {
            const item = items[i];
            if (!item.isActive() || !item.isDutchie()) {
                console.log("Item is not active:", item, item.getStart(), item.getEnd(), item.subscription?.status);
                continue;
            }
            count += item.quantity;
        }
        return count;
    }

    getMaximumMetrcStores() {
        if (this.status !== "active" && this.status !== "trialing") return 0;
        if (isEmpty(this.items)) return 0;
        let count = 0;
        for (let i=0; i < this.items.length; i++) {
            const item = this.items[i];
            if (item.isActive() && item.isMetrc()) {
                count += item.quantity;
            }
        }
        return count;
    }
}

export class Item extends StripeModel {
    static columns = ["id", "external_id", "subscription_id", "product_id", "quantity", "current_period_start", "current_period_end"];
    static uri = "/subscription-items/";
    static pluralName = "items";

    static foreignKeys = {
        subscription: new ForeignKey(Subscription),
        product: new ForeignKey(Product)
    };

    isActive() {
        const now = new Date();
        if (isEmpty(this.current_period_start) || isEmpty(this.current_period_end)) {
            console.log("Item has no start or end time:", this);
            return false;
        }
        const start = this.getStart();
        const end = this.getEnd();
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            console.warn("Could not parse start or end times for item: ", this);
            return false;
        }
        console.log(start, now, end, this.subscription?.status);
        return start <= now && now <= end;
    }

    getStart() {
        const startDateTime = new Date(this.current_period_start);
        startDateTime.setDate(startDateTime.getDate() - 1);
        startDateTime.setHours(0, 0, 0, 0);
        return startDateTime;
    }

    getEnd() {
        return new Date(this.current_period_end);
    }

    isDutchie() {
        return this.product?.isDutchie();
    }

    isMetrc() {
        return this.product?.isMetrc();
    }
}